// FIXME: This should be exported from the ra-core package
type CanAccessParams<
  RecordType extends Record<string, any> = Record<string, any>,
> = {
  action: string;
  resource: string;
  record?: RecordType;
};

export const canAccess = <
  RecordType extends Record<string, any> = Record<string, any>,
>(
  role: string,
  params: CanAccessParams<RecordType>,
) => {
  if (role === "superadmin") {
    return true;
  }

  // Apenas superadmin pode acessar a área de administração de múltiplos CRMs
  if (params.resource === "crms" || params.resource === "admin_crms") {
    return false;
  }

  if (role === "admin") {
    return true;
  }

  // Não-admins não podem acessar áreas críticas de configuração e gestão do sistema
  if (
    params.resource === "sales" ||
    params.resource === "configuration" ||
    params.resource === "settings" ||
    params.resource === "parametrizacao" ||
    params.resource === "api" ||
    params.resource === "api_keys" ||
    params.resource === "api_playground" ||
    params.resource === "api_docs"
  ) {
    return false;
  }

  // Não-admins podem visualizar metas, mas não podem criar, editar ou excluir
  if (
    params.resource === "goals" &&
    (params.action === "create" ||
      params.action === "edit" ||
      params.action === "delete" ||
      params.action === "write")
  ) {
    return false;
  }

  // Apenas administrador dos negócios ou administrador global pode excluir negócios
  if (params.resource === "deals" && params.action === "delete") {
    return false;
  }

  return true;
};
